// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__9f1-t","button":"Search_button__2G_pK","input":"Search_input__mUPTg"};